import type { ClassUnifiedApi } from "../../api/ClassUnifiedApi";
import type { ClassEnrollmentResult } from "../../generated/dto/ClassEnrollmentResult";
import type { ClassInstructorResult } from "../../generated/dto/ClassInstructorResult";
import type { ClassUnifiedCompareClassesRequest } from "../../generated/dto/ClassUnifiedCompareClassesRequest";
import type { ClassUnifiedCreateGuidedSailRequest } from "../../generated/dto/ClassUnifiedCreateGuidedSailRequest";
import type { ClassUnifiedEnrollInstructorRequest } from "../../generated/dto/ClassUnifiedEnrollInstructorRequest";
import type { ClassUnifiedEnrollRequest } from "../../generated/dto/ClassUnifiedEnrollRequest";
import type { ClassUnifiedGuidedSailTimeslotsRequest } from "../../generated/dto/ClassUnifiedGuidedSailTimeslotsRequest";
import type { ClassUnifiedMember } from "../../generated/dto/ClassUnifiedMember";
import type { ClassUnifiedPublic } from "../../generated/dto/ClassUnifiedPublic";
import type { ClassUnifiedSavePersonClassOverrideRequest } from "../../generated/dto/ClassUnifiedSavePersonClassOverrideRequest";
import type { ClassUnifiedSearchClassUnifiedRequest } from "../../generated/dto/ClassUnifiedSearchClassUnifiedRequest";
import type { ClassUnifiedUnenrollInstructorRequest } from "../../generated/dto/ClassUnifiedUnenrollInstructorRequest";
import type { ClassUnifiedUnenrollRequest } from "../../generated/dto/ClassUnifiedUnenrollRequest";
import type { GuidedSailDay } from "../../generated/dto/GuidedSailDay";
import type { PersonClassEnrollment } from "../../generated/dto/PersonClassEnrollment";
import type { PersonClassesPage } from "../../generated/dto/PersonClassesPage";
import type { PersonRef } from "../../generated/dto/PersonRef";
import type { UnifiedClassComparisonReport } from "../../generated/dto/UnifiedClassComparisonReport";
import type { UnifiedClassSearchOptions } from "../../generated/dto/UnifiedClassSearchOptions";
import type { UnifiedStaffClassesResponse } from "../../generated/dto/UnifiedStaffClassesResponse";

export class ClassUnifiedFrontendService {
  constructor(private readonly api: ClassUnifiedApi) {}
  async classesStaff(options: UnifiedClassSearchOptions): Promise<UnifiedStaffClassesResponse> {
    return this.api.classesStaff(options)
  }
  async compareClassesStaff(request: ClassUnifiedCompareClassesRequest): Promise<UnifiedClassComparisonReport> {
    return this.api.compareClassesStaff(request)
  }
  async compareClassesPublic(request: ClassUnifiedCompareClassesRequest): Promise<UnifiedClassComparisonReport> {
    return this.api.compareClassesPublic(request)
  }
  async createGuidedSailStaff(request: ClassUnifiedCreateGuidedSailRequest): Promise<ClassInstructorResult> {
    return this.api.createGuidedSailStaff(request)
  }
  async createGuidedSailMember(request: ClassUnifiedCreateGuidedSailRequest): Promise<ClassInstructorResult> {
    return this.api.createGuidedSailMember(request)
  }
  async enrollStaff(request: ClassUnifiedEnrollRequest): Promise<ClassEnrollmentResult> {
    return this.api.enrollStaff(request)
  }
  async enrollMember(request: ClassUnifiedEnrollRequest): Promise<ClassEnrollmentResult> {
    return this.api.enrollMember(request)
  }
  async enrollInstructorStaff(request: ClassUnifiedEnrollInstructorRequest): Promise<ClassInstructorResult> {
    return this.api.enrollInstructorStaff(request)
  }
  async enrollInstructorMember(request: ClassUnifiedEnrollInstructorRequest): Promise<ClassInstructorResult> {
    return this.api.enrollInstructorMember(request)
  }
  async guidedSailTimeslotsStaff(request: ClassUnifiedGuidedSailTimeslotsRequest): Promise<Array<GuidedSailDay>> {
    return this.api.guidedSailTimeslotsStaff(request)
  }
  async guidedSailTimeslotsMember(request: ClassUnifiedGuidedSailTimeslotsRequest): Promise<Array<GuidedSailDay>> {
    return this.api.guidedSailTimeslotsMember(request)
  }
  async memberClassesMember(options: UnifiedClassSearchOptions): Promise<Array<ClassUnifiedMember>> {
    return this.api.memberClassesMember(options)
  }
  async personEnrollmentsStaff(person: PersonRef): Promise<Array<PersonClassEnrollment>> {
    return this.api.personEnrollmentsStaff(person)
  }
  async personEnrollmentsMember(person: PersonRef): Promise<Array<PersonClassEnrollment>> {
    return this.api.personEnrollmentsMember(person)
  }
  async publicClassesPublic(options: UnifiedClassSearchOptions): Promise<Array<ClassUnifiedPublic>> {
    return this.api.publicClassesPublic(options)
  }
  async savePersonClassOverrideStaff(request: ClassUnifiedSavePersonClassOverrideRequest): Promise<void> {
    return this.api.savePersonClassOverrideStaff(request)
  }
  async searchClassUnifiedStaff(request: ClassUnifiedSearchClassUnifiedRequest): Promise<PersonClassesPage> {
    return this.api.searchClassUnifiedStaff(request)
  }
  async unenrollStaff(request: ClassUnifiedUnenrollRequest): Promise<ClassEnrollmentResult> {
    return this.api.unenrollStaff(request)
  }
  async unenrollMember(request: ClassUnifiedUnenrollRequest): Promise<ClassEnrollmentResult> {
    return this.api.unenrollMember(request)
  }
  async unenrollInstructorStaff(request: ClassUnifiedUnenrollInstructorRequest): Promise<ClassInstructorResult> {
    return this.api.unenrollInstructorStaff(request)
  }
  async unenrollInstructorMember(request: ClassUnifiedUnenrollInstructorRequest): Promise<ClassInstructorResult> {
    return this.api.unenrollInstructorMember(request)
  }
}
